angular.module('admin.reports').config(($stateProvider) => {
    $stateProvider.state('admin.reports', {
        controller: function () {

        }, template: '<ui-view />'
    });

    function createPermissions(name) { return {
        permissions: { only: name}
    }}

    $stateProvider.state('admin.reports.basic', {
        url: 'reports/basic',
        controller: 'BasicReportCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/basic.html',
        data: createPermissions('reports.basic')
    }).state('admin.reports.myce', {
        url: 'reports/myce',
        controller: 'MyCeReportCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/myce.html',
        data: createPermissions('reports.myce')
    }).state('admin.reports.favs', {
        url: 'reports/favorites',
        controllerAs: 'ctrl',
        controller: 'FavoritesReportCtrl',
        templateUrl: 'views/reports/favorites.html',
        data: createPermissions('reports.favorites')
    }).state('admin.reports.revenues', {
        url: 'reports/revenues',
        controller: 'RevenuesReportCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/revenues.html',
        data: createPermissions('reports.revenues')
    }).state('admin.reports.revenue_report', {
        url: 'reports/revenues/:reportId',
        controller: 'RevenueReportDetailCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/revenues_detail.html',
        data: createPermissions('reports.revenues')
    }).state('admin.reports.subscriptions', {
        url: 'reports/subscriptions',
        controller: 'SubscriptionsFlowReportCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/subscriptions_flow.html',
        data: createPermissions('reports.subscriptions_flow')
    }).state('admin.reports.revenues2', {
        url: 'reports/revenues2',
        controller: 'RevenueReport2Ctrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/revenues2.html',
        data: createPermissions('reports.revenues')
    }).state('admin.reports.mailing', {
        url: 'reports/mailing',
        controller: 'MailingReportCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/mailing.html',
        data: createPermissions('reports.mailing')
    }).state('admin.reports.commercial', {
        url: 'reports/commercial',
        controller: 'CommercialReportCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/commercial.html',
        data: createPermissions('reports.commercial_report')
    }).state('admin.reports.removed_subordinates', {
        url: 'reports/removed_subordinates',
        controller: 'RemovedSubordinatesReportCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'views/reports/removed_subordinates.html',
        data: createPermissions('reports.removed_subordinates')
    });
});
